// iter164 — Ürün paylaşım bar'ı: WhatsApp + Web Share (native) + Copy + Facebook + X
import { useState } from "react";
import { MessageCircle, Copy, Share2, Facebook, Check } from "lucide-react";
import { toast } from "sonner";
import { fmtTRY } from "../../lib/format";

export default function ShareBar({ product, url }) {
  const [copied, setCopied] = useState(false);
  if (!product) return null;
  const brand = product.brand_name ? ` · ${product.brand_name}` : "";
  const priceLine = product.price > 0 ? `\n💰 ${fmtTRY(product.price)} (KDV Dahil)` : "";
  const skuLine = product.sku ? `\n🏷️ Kod: ${product.sku}` : "";
  const richText = `🛒 *${product.name}*${brand}${priceLine}${skuLine}\n\n👉 ${url}\n\nBordo Seramik — Adana Yapı & Seramik`;
  const encoded = encodeURIComponent(richText);
  const urlEnc = encodeURIComponent(url);
  const titleEnc = encodeURIComponent(product.name);

  const openWhatsApp = () => window.open(`https://wa.me/?text=${encoded}`, "_blank", "noopener,noreferrer");
  const openFacebook = () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${urlEnc}`, "_blank", "noopener,noreferrer", "width=580,height=600");
  const openTwitter  = () => window.open(`https://twitter.com/intent/tweet?url=${urlEnc}&text=${titleEnc}`, "_blank", "noopener,noreferrer", "width=580,height=600");
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true); toast.success("Ürün bağlantısı kopyalandı");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Kopyalanamadı"); }
  };
  const nativeShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: product.name, text: `${product.name}${brand}${priceLine}`, url });
      } else {
        copyLink();
      }
    } catch { /* user cancel */ }
  };

  return (
    <div className="mt-6 mb-8 p-4 rounded-2xl border border-zinc-100 bg-gradient-to-br from-zinc-50/60 to-white" data-testid="pd-share-bar">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-zinc-600 font-bold">
          <Share2 size={12}/> Ürünü Paylaş
        </div>
        <button onClick={nativeShare} className="md:hidden text-[11px] text-primary font-semibold" data-testid="pd-share-native">
          Diğer uygulamalar →
        </button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        <button onClick={openWhatsApp} data-testid="pd-share-whatsapp"
                className="flex items-center justify-center gap-2 py-2.5 rounded-full bg-[#25D366] hover:bg-[#20b757] text-white text-[13px] font-semibold shadow-sm active:scale-95 transition-transform">
          <MessageCircle size={15}/> WhatsApp
        </button>
        <button onClick={openFacebook} data-testid="pd-share-facebook"
                className="flex items-center justify-center gap-2 py-2.5 rounded-full bg-[#1877F2] hover:bg-[#1461c9] text-white text-[13px] font-semibold shadow-sm active:scale-95 transition-transform">
          <Facebook size={15}/> Facebook
        </button>
        <button onClick={openTwitter} data-testid="pd-share-twitter"
                className="flex items-center justify-center gap-2 py-2.5 rounded-full bg-zinc-900 hover:bg-zinc-800 text-white text-[13px] font-semibold shadow-sm active:scale-95 transition-transform">
          <span className="font-black text-[15px] leading-none">𝕏</span> Twitter
        </button>
        <button onClick={copyLink} data-testid="pd-share-copy"
                className="flex items-center justify-center gap-2 py-2.5 rounded-full border border-zinc-200 bg-white hover:border-primary hover:text-primary text-zinc-700 text-[13px] font-semibold active:scale-95 transition-all">
          {copied ? <Check size={15} className="text-emerald-600"/> : <Copy size={15}/>}
          {copied ? "Kopyalandı" : "Linki Kopyala"}
        </button>
      </div>
    </div>
  );
}
